import { RJSF_CUSTOM_PREFIX
} from "../appConstants";

/**
 * Form headers have 'rjsf_prefix' as id.
 * All other form attributes are added as suffix to 'rjsf_prefix'
 * e.g. Attribute enterProductDetails will have id as 'rjsf_prefix_enterProductDetails'
 * @param id
 */
export const isFormHeaderField = (id: string) => (
    id === RJSF_CUSTOM_PREFIX
);

export const isObjectEmpty = (obj: any) => {
    return Object.keys(obj).length === 0
}